import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.array.is-array";
import _get from "lodash/get";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { createAction } from 'redux-act';
import url from 'url';
import * as Constants from "../constants";
export var trackAuthStepChange = createAction('TRACK: Step Changed', function (newStep, previousStep, previousStepShownAt) {
  return {
    previousStep: previousStep,
    newStep: newStep,
    previousStepShownAt: previousStepShownAt
  };
});
export var trackAuthComponentSuccess = createAction('TRACK: Auth component success', function (flow) {
  return {
    flow: Array.isArray(flow) ? 'custom' : flow
  };
});
export var trackAuthComponentShow = createAction('TRACK: Auth component shown', function (flow) {
  return {
    flow: Array.isArray(flow) ? 'custom' : flow
  };
});
export var trackAuthModalShow = createAction('TRACK: Auth modal shown');
export var trackAuthModalClose = createAction('TRACK: Auth modal closed', function (closedBy, currentStep) {
  return {
    closedBy: closedBy,
    currentStep: currentStep
  };
});
export var trackCarouselInteraction = createAction('TRACK: Carousel Interaction'); // ****************************************************

var getQuery = function getQuery() {
  if (typeof window === 'undefined') return {};
  var result;

  try {
    result = _get(url.parse(window.location.href, true), 'query', {});
  } catch (e) {
    result = {};
  }

  return result;
};

var getPageTaxonomy = function getPageTaxonomy() {
  if (typeof window === 'undefined') return {};
  return _get(window, 'nwPageTaxonomy', {});
};

var getLegacyTrkParams = function getLegacyTrkParams() {
  var query = getQuery();
  return {
    trk_origin: query.trk_origin,
    trk_source: query.trk_source,
    trk_version: query.trk_version,
    trk_location: query.trk_location,
    trk_format: query.trk_format
  };
};

export var updateTrackingParams = createAction('TRACK: Update tracking params', function (_ref) {
  var _ref$trk = _ref.trk,
      trk = _ref$trk === void 0 ? {} : _ref$trk,
      _ref$amplitudeOnlyTrk = _ref.amplitudeOnlyTrk,
      amplitudeOnlyTrk = _ref$amplitudeOnlyTrk === void 0 ? {} : _ref$amplitudeOnlyTrk,
      appName = _ref.appName;
  var query = getQuery();

  var trkParams = _objectSpread(_objectSpread({}, getLegacyTrkParams()), {}, {
    trk_mode: Constants.Mode.EMBED,
    trk_channel: query.utm_medium === 'email' ? Constants.Channel.EMAIL : Constants.Channel.WEB
  });

  if (trkParams.trk_channel === 'web') {
    var nwPageTaxonomy = getPageTaxonomy();
    trkParams = _objectSpread(_objectSpread({}, trkParams), {}, {
      trk_vertical: query.trk_vertical || nwPageTaxonomy.vertical,
      trk_topic: query.trk_topic || nwPageTaxonomy.topic,
      trk_nldt: query.trk_nldt || nwPageTaxonomy.pageType,
      trk_pagetype: query.trk_pagetype || nwPageTaxonomy.contentType,
      trk_element: query.trk_element || Constants.Element.DEFAULT,
      trk_location: query.trk_location,
      trk_copy: query.trk_copy
    });
  }

  return {
    trk: _objectSpread(_objectSpread({}, trkParams), trk),
    amplitudeOnlyTrk: amplitudeOnlyTrk,
    appName: appName
  };
});